module.exports = __webpack_public_path__ + "img/1.cbf49a54.png";